<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :parentStoreName="parentStoreName"
    :parentUrlKey="parentUrlKey"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="is_available"
                rules="required"
                v-slot="{ errors }"
              >
                <v-checkbox
                  :error-messages="errors"
                  v-model="data.is_available"
                  label="Disponible"
                ></v-checkbox>
              </ValidationProvider>
            </v-col>

            <v-col>
              <ValidationProvider
                ref="day"
                rules="required"
                v-slot="{ errors }"
              >
                <v-menu
                  ref="day"
                  v-model="menu_dob"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                  :error-messages="errors"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="data.day"
                      label="Día"
                      prepend-icon="fas fa-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="day"
                    label="Día"
                    type="date"
                    no-title
                    scrollable
                    @change="menu_dob = false"
                  >
                  </v-date-picker>
                </v-menu>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm },
  computed: {
    ...mapState({})
  },
  data() {
    return {
      storeName: "Availability_days",
      title: "Availability_days",
      parentStoreName: "professionals",
      parentUrlKey: "professional_id",
      show1: false,
      day: "",
      menu_dob: false,
      data: {
        day: "",
        is_available: false,
        professional_id:''
      }
    };
  },
  watch: {
    day(val) {
      this.day = val;
      this.data.day = this.formatDateForSave(val);
    },
  },
  created() {
    console.log(this.data);
    if(this.$route.params.professional_id) this.data.professional_id=this.$route.params.professional_id;
  },
};
</script>
